export const CONTENT = {
  it: {
    brand: "R.P. Limousine Milano",
    nav: { services: "Servizi", fleet: "Flotta", rates: "Tariffe", contact: "Contatti", account: "Area Clienti", login: "Accedi con Google", call: "Chiama ora" },
    hero: {
      badge: "NCC con regolare licenza comunale",
      titleA: "Il tuo chauffeur privato",
      titleB: "a Milano.",
      sub: "Trasferimenti aeroportuali, business travel ed eventi esclusivi. Preventivo istantaneo, prezzo bloccato, pagamento online o a bordo.",
      cta: "Prenota la tua corsa",
      trust: ["Licenza comunale NCC", "Servizio 24/7", "Monitoraggio voli", "Autisti professionisti"],
    },
    popular: {
      title: "Tratte popolari — prezzo fisso",
      routes: [
        { label: "Milano ↔ Malpensa (MXP)", price: "a partire da €130" },
        { label: "Milano ↔ Linate (LIN)", price: "a partire da €60" },
        { label: "Milano ↔ Orio al Serio (BGY)", price: "a partire da €140" },
        { label: "Milano ↔ Lago di Como", price: "a partire da €160" },
        { label: "Disposizione oraria", price: "a partire da €70/h" },
      ],
    },
    booking: {
      title: "Prenota in 30 secondi",
      subtitle: "Preventivo istantaneo e prezzo bloccato. Nessuna sorpresa.",
      pickup: "Partenza",
      pickupPh: "Es. Malpensa T1, Stazione Centrale, hotel…",
      dropoff: "Destinazione",
      dropoffPh: "Es. Duomo di Milano, Como, indirizzo…",
      date: "Data",
      time: "Ora",
      passengers: "Passeggeri",
      vehicle: "Scegli il veicolo",
      calc: "Calcola preventivo",
      calculating: "Calcolo…",
      quoteTitle: "Il tuo preventivo",
      route: "Tratta",
      base: "Tariffa base",
      vehicleClass: "Classe veicolo",
      total: "Totale",
      fixed: "Prezzo bloccato · tasse incluse",
      night: "Supplemento notturno (22:00–6:00)",
      holiday: "Supplemento festivo (dom e festivi)",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      payOnline: "Paga online",
      payOnboard: "Prenota, paga a bordo",
      whatsapp: "WhatsApp",
      secure: "Pagamento sicuro Stripe · Carte, Apple Pay, Google Pay",
      confirmedTitle: "Prenotazione confermata",
      confirmedSub: "Riceverai una conferma a breve. Pagherai comodamente a bordo.",
      newBooking: "Nuova prenotazione",
      errFields: "Compila partenza, destinazione, data e ora",
      errContact: "Inserisci nome, email e telefono",
      suggestions: ["Aeroporto Malpensa (MXP)", "Aeroporto Linate (LIN)", "Aeroporto Orio al Serio (BGY)", "Lago di Como / Bellagio", "Stazione Centrale Milano", "Duomo di Milano", "Fiera Milano Rho"],
    },
    vehicles: {
      eclass: { name: "Mercedes Classe E", desc: "Business Class · 3 passeggeri · 3 bagagli" },
      sclass: { name: "Mercedes Classe S", desc: "First Class · 3 passeggeri · massimo comfort" },
      vclass: { name: "Mercedes Classe V", desc: "Luxury Van · fino a 7 passeggeri" },
    },
    fleet: {
      label: "La flotta",
      title: "Mercedes-Benz, solo ultima generazione",
      sub: "Wi-Fi a bordo, acqua, caricabatterie e autista in divisa. Sempre.",
      specs: { wifi: "Wi-Fi", water: "Acqua", charger: "Caricabatterie", leather: "Pelle" },
    },
    services: {
      label: "I servizi",
      title: "Ogni viaggio, su misura",
      items: [
        { title: "Transfer aeroportuali", desc: "Malpensa, Linate e Orio al Serio con monitoraggio del volo e attesa gratuita." },
        { title: "Business & Fashion Week", desc: "Disposizione oraria per meeting, showroom ed eventi. Massima discrezione." },
        { title: "Lago di Como & tour", desc: "Gite di un giorno tra Bellagio, Varenna e le cantine della Franciacorta." },
        { title: "Matrimoni & eventi", desc: "Arrivi scenografici e coordinamento completo per il tuo giorno speciale." },
      ],
    },
    trust: {
      label: "Perché noi",
      title: "La fiducia si guadagna a ogni chilometro",
      points: [
        { title: "Licenza comunale NCC", desc: "Regolare licenza comunale NCC, con accesso a ZTL e corsie preferenziali." },
        { title: "Assicurazione passeggeri", desc: "Copertura massimale estesa su ogni corsa, sempre inclusa." },
        { title: "Puntualità garantita", desc: "Monitoraggio voli e traffico in tempo reale. L'autista arriva prima, mai dopo." },
        { title: "Prezzo bloccato", desc: "Il preventivo che vedi è il prezzo che paghi. Nessun supplemento nascosto." },
      ],
      reviewsLabel: "Dicono di noi",
      reviews: [
        { name: "Giulia R.", text: "Autista puntuale alle 4:30 per Malpensa, auto impeccabile. Non viaggio più con nessun altro." },
        { name: "Marco T.", text: "Uso R.P. per tutti i transfer aziendali. Fatturazione semplice e servizio di altissimo livello." },
        { name: "Elena & Paul", text: "Ci hanno accompagnato al matrimonio sul Lago di Como. Eleganza e discrezione perfette." },
      ],
    },
    driverTeaser: {
      title: "Autista o flotta partner?",
      sub: "La nostra app per le corse è in arrivo. Unisciti al network R.P. Limousine.",
      cta: "Candidati via email",
    },
    footer: {
      tagline: "Servizio chauffeur di lusso a Milano e Lombardia.",
      contacts: "Contatti",
      legal: "R.P. Limousine Milano S.r.l. · Licenza NCC · Milano, Italia",
      hours: "Disponibili 24 ore su 24, 7 giorni su 7",
    },
    account: {
      title: "Area Clienti",
      welcome: "Bentornato",
      loginPrompt: "Accedi con Google per vedere le tue prenotazioni e riprendere le corse salvate.",
      myBookings: "Le mie prenotazioni",
      noBookings: "Nessuna prenotazione ancora. Prenota la tua prima corsa dalla home.",
      logout: "Esci",
      date: "Data",
      route: "Tratta",
      vehicle: "Veicolo",
      amount: "Importo",
      status: "Stato",
      paid: "Pagato",
      pendingPayment: "In attesa di pagamento",
      payOnboard: "Pagamento a bordo",
      confirmed: "Confermata",
      loading: "Caricamento…",
      edit: "Modifica",
      cancelBooking: "Annulla corsa",
      confirmCancel: "Conferma annullamento",
      save: "Salva modifiche",
      closeEdit: "Chiudi",
      updatedOk: "Prenotazione aggiornata",
      cancelledOk: "Prenotazione annullata",
      refundedNote: "Rimborso avviato automaticamente sulla tua carta",
      paidLocked: "Pagata online: per modifiche scrivici su WhatsApp",
      yourDriver: "Il tuo autista",
    },
    payment: {
      successTitle: "Pagamento completato",
      successSub: "La tua corsa è confermata. Riceverai i dettagli via email.",
      checking: "Verifica del pagamento in corso…",
      stillPending: "Pagamento in elaborazione — aggiorneremo lo stato a breve.",
      cancelTitle: "Pagamento annullato",
      cancelSub: "Nessun addebito effettuato. Puoi riprovare quando vuoi.",
      backHome: "Torna alla home",
      viewAccount: "Vai all'area clienti",
    },
  },
  en: {
    brand: "R.P. Limousine Milano",
    nav: { services: "Services", fleet: "Fleet", rates: "Rates", contact: "Contact", account: "My Account", login: "Sign in with Google", call: "Call now" },
    hero: {
      badge: "Municipally licensed chauffeur service",
      titleA: "Your private chauffeur",
      titleB: "in Milan.",
      sub: "Airport transfers, business travel and exclusive events across Milan and Lombardy. Instant quote, locked price, pay online or on board.",
      cta: "Book your ride",
      trust: ["Municipal NCC licence", "24/7 service", "Flight tracking", "Professional chauffeurs"],
    },
    popular: {
      title: "Popular routes — flat rate",
      routes: [
        { label: "Milan ↔ Malpensa (MXP)", price: "from €130" },
        { label: "Milan ↔ Linate (LIN)", price: "from €60" },
        { label: "Milan ↔ Orio al Serio (BGY)", price: "from €140" },
        { label: "Milan ↔ Lake Como", price: "from €160" },
        { label: "Hourly disposal", price: "from €70/h" },
      ],
    },
    booking: {
      title: "Book in 30 seconds",
      subtitle: "Instant quote, locked price. No surprises.",
      pickup: "Pickup",
      pickupPh: "E.g. Malpensa T1, Central Station, hotel…",
      dropoff: "Drop-off",
      dropoffPh: "E.g. Milan Duomo, Como, address…",
      date: "Date",
      time: "Time",
      passengers: "Passengers",
      vehicle: "Choose your vehicle",
      calc: "Get instant quote",
      calculating: "Calculating…",
      quoteTitle: "Your quote",
      route: "Route",
      base: "Base fare",
      vehicleClass: "Vehicle class",
      total: "Total",
      fixed: "Locked price · taxes included",
      night: "Night surcharge (10pm–6am)",
      holiday: "Holiday surcharge (Sun & holidays)",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      payOnline: "Pay online",
      payOnboard: "Book now, pay on board",
      whatsapp: "WhatsApp",
      secure: "Secure Stripe payment · Cards, Apple Pay, Google Pay",
      confirmedTitle: "Booking confirmed",
      confirmedSub: "You will receive a confirmation shortly. Pay comfortably on board.",
      newBooking: "New booking",
      errFields: "Please fill in pickup, drop-off, date and time",
      errContact: "Please enter name, email and phone",
      suggestions: ["Malpensa Airport (MXP)", "Linate Airport (LIN)", "Orio al Serio Airport (BGY)", "Lake Como / Bellagio", "Milan Central Station", "Milan Duomo", "Fiera Milano Rho"],
    },
    vehicles: {
      eclass: { name: "Mercedes E-Class", desc: "Business Class · 3 passengers · 3 bags" },
      sclass: { name: "Mercedes S-Class", desc: "First Class · 3 passengers · ultimate comfort" },
      vclass: { name: "Mercedes V-Class", desc: "Luxury Van · up to 7 passengers" },
    },
    fleet: {
      label: "The fleet",
      title: "Nothing but latest-generation Mercedes-Benz",
      sub: "On-board Wi-Fi, water, chargers and a chauffeur in uniform. Always.",
      specs: { wifi: "Wi-Fi", water: "Water", charger: "Chargers", leather: "Leather" },
    },
    services: {
      label: "Services",
      title: "Every journey, tailored to you",
      items: [
        { title: "Airport transfers", desc: "Malpensa, Linate and Orio al Serio with flight tracking and free waiting time." },
        { title: "Business & Fashion Week", desc: "Hourly disposal for meetings, showrooms and events. Utmost discretion." },
        { title: "Lake Como & tours", desc: "Day trips across Bellagio, Varenna and the Franciacorta wineries." },
        { title: "Weddings & events", desc: "Scenic arrivals and full coordination for your special day." },
      ],
    },
    trust: {
      label: "Why us",
      title: "Trust is earned every kilometre",
      points: [
        { title: "Municipal NCC licence", desc: "Regular municipal NCC licence, with access to restricted zones and priority lanes." },
        { title: "Passenger insurance", desc: "Extended coverage included on every single ride." },
        { title: "Guaranteed punctuality", desc: "Real-time flight and traffic tracking. Your chauffeur arrives early, never late." },
        { title: "Locked price", desc: "The quote you see is the price you pay. No hidden surcharges." },
      ],
      reviewsLabel: "What clients say",
      reviews: [
        { name: "Giulia R.", text: "Chauffeur on time at 4:30 am for Malpensa, spotless car. I never travel with anyone else." },
        { name: "Marco T.", text: "I use R.P. for all corporate transfers. Simple invoicing and top-level service." },
        { name: "Elena & Paul", text: "They drove us to our wedding on Lake Como. Perfect elegance and discretion." },
      ],
    },
    driverTeaser: {
      title: "Driver or partner fleet?",
      sub: "Our ride app is coming soon. Join the R.P. Limousine network.",
      cta: "Apply via email",
    },
    footer: {
      tagline: "Luxury chauffeur service in Milan and Lombardy.",
      contacts: "Contacts",
      legal: "R.P. Limousine Milano S.r.l. · NCC License · Milan, Italy",
      hours: "Available 24 hours a day, 7 days a week",
    },
    account: {
      title: "My Account",
      welcome: "Welcome back",
      loginPrompt: "Sign in with Google to see your bookings and saved rides.",
      myBookings: "My bookings",
      noBookings: "No bookings yet. Book your first ride from the homepage.",
      logout: "Sign out",
      date: "Date",
      route: "Route",
      vehicle: "Vehicle",
      amount: "Amount",
      status: "Status",
      paid: "Paid",
      pendingPayment: "Pending payment",
      payOnboard: "Pay on board",
      confirmed: "Confirmed",
      loading: "Loading…",
      edit: "Edit",
      cancelBooking: "Cancel ride",
      confirmCancel: "Confirm cancellation",
      save: "Save changes",
      closeEdit: "Close",
      updatedOk: "Booking updated",
      cancelledOk: "Booking cancelled",
      refundedNote: "Refund automatically started to your card",
      paidLocked: "Paid online: message us on WhatsApp for changes",
      yourDriver: "Your chauffeur",
    },
    payment: {
      successTitle: "Payment completed",
      successSub: "Your ride is confirmed. You will receive the details by email.",
      checking: "Verifying your payment…",
      stillPending: "Payment is being processed — we will update the status shortly.",
      cancelTitle: "Payment cancelled",
      cancelSub: "No charge was made. You can try again anytime.",
      backHome: "Back to home",
      viewAccount: "Go to my account",
    },
  },
};
